import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";
import * as _ from "lodash";
import {RouteEditValidationResultEnum} from "../types/route-edit-validation-result.enum";

export class LeanPlanningAlertsService {

  constructor(private bringozToastService: BringozToastService, private $translate) {
  }

  // CREATE_ONE //
  createOneSuccess() {
    const message = {
      body: 'LEAN_PLANNING_CREATE_ONE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }


  createOneError() {
    const message = {
      body: 'LEAN_PLANNING_CREATE_ONE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // CREATE MANY //
  createManySuccess() {
    const message = {
      body: 'LEAN_PLANNING_CREATE_MANY_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }


  createManyError() {
    const message = {
      body: 'LEAN_PLANNING_CREATE_MANY_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // ASSIGN //
  assignSuccess() {
    const message = {
      body: 'LEAN_PLANNING_ASSIGN_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  assignError() {
    const message = {
      body: 'LEAN_PLANNING_ASSIGN_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  assignRouteCannotBeCreatedError() {
    const message = {
      body: 'LEAN_PLANNING_ROUTE_CANNOT_BE_CREATED_ERROR'
    };
    return this.bringozToastService.error(message, {}, 'Force')
  }

  // ASSIGN MANY //
  assignManySuccess() {
    const message = {
      body: 'LEAN_PLANNING_ASSIGN_MANY_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  assignManyError() {
    const message = {
      body: 'LEAN_PLANNING_ASSIGN_MANY_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // ASSIGN_ASSISTANTS //
  assignAssistantsSuccess() {
    const message = {
      body: 'LEAN_PLANNING_ASSIGN_ASSISTANTS_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  assignAssistantsError() {
    const message = {
      body: 'LEAN_PLANNING_ASSIGN_ASSISTANTS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // MERGE ROUTES //
  mergeRoutesSuccess() {
    const message = {
      body: 'LEAN_PLANNING_MERGE_ROUTES_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }


  mergeRoutesError() {
    const message = {
      body: 'LEAN_PLANNING_MERGE_ROUTES_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // RESET //


  resetSuccess() {
    const message = {
      body: 'LEAN_PLANNING_RESET_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }


  resetError() {
    const message = {
      body: 'LEAN_PLANNING_RESET_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // RESET MANY //


  resetManySuccess() {
    const message = {
      body: 'LEAN_PLANNING_RESET_MANY_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }


  resetManyError() {
    const message = {
      body: 'LEAN_PLANNING_RESET_MANY_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DELETE //


  deleteOneSuccess(route?) {
    const message = {
      body: 'X_LEAN_PLANNING_DELETE_ONE_SUCCESS'
    };
    return this.bringozToastService.success(message, route)
  }


  deleteOneError() {
    const message = {
      body: 'LEAN_PLANNING_DELETE_ONE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DELETE MANY //


  deleteManySuccess(customer?) {
    const message = {
      body: 'LEAN_PLANNING_DELETE_MANY_SUCCESS'
    };
    let name;
    if (customer) {
      name = customer.firstName + " " + customer.lastName;
    }
    return this.bringozToastService.success(message, {name: name})
  }


  deleteManyError() {
    const message = {
      body: 'LEAN_PLANNING_DELETE_MANY_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE TASK//
  updateTaskSuccess() {
    const message = {
      body: 'LEAN_PLANNING_UPDATE_TASK_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  // UPDATE //
  updateSuccess() {
    const message = {
      body: 'LEAN_PLANNING_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateError() {
    const message = {
      body: 'LEAN_PLANNING_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE MANY //

  updateManySuccess() {
    const message = {
      body: 'LEAN_PLANNING_UPDATE_MANY_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }


  updateManyError() {
    const message = {
      body: 'LEAN_PLANNING_UPDATE_MANY_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // RE OPTIMIZE //

  reOptimizeSuccess() {
    const message = {
      body: 'LEAN_PLANNING_RE_OPTIMIZE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }


  reOptimizeError() {
    const message = {
      body: 'LEAN_PLANNING_RE_OPTIMIZE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // RE OPTIMIZE MANY //

  reOptimizeManySuccess() {
    const message = {
      body: 'LEAN_PLANNING_RE_OPTIMIZE_MANY_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }


  reOptimizeManyError() {
    const message = {
      body: 'LEAN_PLANNING_RE_OPTIMIZE_MANY_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // REMOVE UNPACKED //

  removeUnpackedSuccess() {
    const message = {
      body: 'LEAN_PLANNING_REMOVE_UNPACKED_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }


  removeUnpackedError() {
    const message = {
      body: 'LEAN_PLANNING_REMOVE_UNPACKED_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // REMOVE TASK //

  removeTaskSuccess() {
    const message = {
      body: 'LEAN_PLANNING_REMOVE_TASK_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }


  removeTaskError() {
    const message = {
      body: 'LEAN_PLANNING_REMOVE_TASK_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // ADD DELIVERY //

  addDeliverySuccess(route) {
    const message = {
      body: 'X_LEAN_PLANNING_ADD_DELIVERY_SUCCESS'
    };
    return this.bringozToastService.success(message, route)
  }


  addDeliveryError() {
    const message = {
      body: 'LEAN_PLANNING_ADD_DELIVERY_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // ADD DELIVERIES //

  addDeliveriesSuccess(route?) {
    const message = {
      body: 'X_LEAN_PLANNING_ADD_DELIVERIES_SUCCESS'
    };
    return this.bringozToastService.success(message, route)
  }


  addDeliveriesError() {
    const message = {
      body: 'LEAN_PLANNING_ADD_DELIVERIES_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // CANCEL GENERATING //

  cancelGeneratingSuccess() {
    const message = {
      body: 'LEAN_PLANNING_CANCEL_GENERATING_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }


  cancelGeneratingError() {
    const message = {
      body: 'LEAN_PLANNING_CANCEL_GENERATING_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE ROUTING SETTINGS //

  updateRoutingSettingsSuccess() {
    const message = {
      body: 'LEAN_PLANNING_UPDATE_ROUTING_SETTINGS_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }


  updateRoutingSettingsError() {
    const message = {
      body: 'LEAN_PLANNING_UPDATE_ROUTING_SETTINGS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // CANCEL GENERATING ROUTES //

  cancelGeneratingRoutesSuccess() {
    const message = {
      body: 'LEAN_PLANNING_CANCEL_GENERATING_ROUTES_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }


  cancelGeneratingRoutesError() {
    const message = {
      body: 'LEAN_PLANNING_CANCEL_GENERATING_ROUTES_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // GET SUGGESTED DELIVERIES //

  getSuggestionsSuccess() {
    const message = {
      body: 'LEAN_PLANNING_GET_SUGGESTED_DELIVERIES_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  // GET SUGGESTED DELIVERIES //

  getSuggestionsError() {
    const message = {
      body: 'LEAN_PLANNING_GET_SUGGESTED_DELIVERIES_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // GET TIMELINE //
  getTimelineError() {
    const message = {
      body: 'LEAN_PLANNING_GET_TIMELINE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // GET BOL //
  getBOLError() {
    const message = {
      body: 'LEAN_PLANNING_GET_BOL_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // GET ROUTE //
  getRouteError() {
    const message = {
      body: 'LEAN_PLANNING_GET_ROUTE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // MERGE SEGMENTS //

  mergeSegmentsSuccess() {
    const message = {
      body: 'LEAN_PLANNING_MERGE_SEGMENTS_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }


  mergeSegmentsError() {
    const message = {
      body: 'LEAN_PLANNING_MERGE_SEGMENTS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // SPLIT SEGMENTS //
  splitSegmentsSuccess() {
    const message = {
      body: 'LEAN_PLANNING_SPLIT_SEGMENTS_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  splitSegmentsError() {
    const message = {
      body: 'LEAN_PLANNING_SPLIT_SEGMENTS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE_ROUTE //
  updateRouteSuccess() {
    const message = {
      body: 'LEAN_PLANNING_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateRouteError() {
    const message = {
      body: 'LEAN_PLANNING_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE_RESOURCE //
  updateResourceSuccess() {
    const message = {
      body: 'LEAN_PLANNING_UPDATE_RESOURCE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateResourceRouteError() {
    const message = {
      body: 'LEAN_PLANNING_UPDATE_RESOURCE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // CHANGE_ROUTE_RESOURCE //
  changeRouteResourceSuccess() {
    const message = {
      body: 'LEAN_PLANNING_CHANGE_ROUTE_RESOURCE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  changeRouteResourceError() {
    const message = {
      body: 'LEAN_PLANNING_CHANGE_ROUTE_RESOURCE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // EDIT_GROUP_SEQUENCE //
  editGroupSequenceSuccess() {
    const message = {
      body: 'LEAN_PLANNING_EDIT_GROUP_SEQUENCE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  editGroupSequenceError() {
    const message = {
      body: 'LEAN_PLANNING_EDIT_GROUP_SEQUENCE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // BLOCK_ROUTE //
  blockRouteSuccess() {
    const message = {
      body: 'LEAN_PLANNING_BLOCK_ROUTE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  blockRouteError() {
    const message = {
      body: 'LEAN_PLANNING_BLOCK_ROUTE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UNBLOCK_ROUTE //
  unblockRouteSuccess() {
    const message = {
      body: 'LEAN_PLANNING_UNBLOCK_ROUTE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  unblockRouteError() {
    const message = {
      body: 'LEAN_PLANNING_UNBLOCK_ROUTE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }
  validateAssignmentError(reason: RouteEditValidationResultEnum) {
    const message = {
      details: 'LEAN_PLANNING_VALIDATE_ASSIGNMENT_ERROR',
      body: reason
    };
    return this.bringozToastService.error(message)
  }

  alreadyInRouteInfo() {
    const message = {
      body: 'LEAN_PLANNING_TASK_ALREADY_IN_ROUTE_INFO'
    };
    return this.bringozToastService.info(message)
  }

  serviceFinishedInfo(status) {
    const message = {
      body: 'LEAN_PLANNING_SERVICE_FINISHED_INFO'
    };
    return this.bringozToastService.info(message, {status: this.$translate.instant(status)})
  }

}

angular
  .module('bringoz.admin.lean-planning')
  .service('leanPlanningAlertsService', LeanPlanningAlertsService);
